import React from 'react';
import { useGetIntegrations } from '../hooks/integrations';
import { IntegrationParameterManager } from './IntegrationParameterManager';

interface IntegrationDetailsProps {
    domain: string;
}

const IntegrationDetails = ({ domain }: IntegrationDetailsProps) => {
    const { data: rawIntegrations, isLoading } = useGetIntegrations();
    const integrations = rawIntegrations || [];
    return (
        <>
            {integrations
                .filter((integration) => integration.function === domain)
                .map((integration) => (
                    <IntegrationParameterManager
                        integration={integration}
                        isIntegrationLoading={isLoading}
                        key={integration.slug}
                    />
                ))}
        </>
    );
};

export default IntegrationDetails;
